import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtilsService } from '../../commons/http-uilis.service';
import { Observable, of } from 'rxjs';
import { Paging } from '../../../model/paging/paging';
import { environment } from '../../../environment/environment';
import { UserList } from '../../../model/user/users-list';
import { EmailLicense } from '../../../model/email-license/email-license';

@Injectable({
  providedIn: 'root'
})
export class UserService_Mock {
  private _url: string = `${environment.baseAPIURL}/settings`;

  constructor(private _http: HttpClient, private _httpUtils: HttpUtilsService) {}

  GETPaginatedUsers(paging: Paging): Observable<UserList> | any {
    const allData = [
      {
        userId: "user-1",
        name: "Mario",
        lastName: "Rossi",
        email: "mario.rossi@example.com",
        companyName: "Acme S.p.A.",
        piva: "IT12345678901",
        street: "Via Roma 1",
        city: "Milano",
        zip: "20100",
        province: "MI",
        state: "IT",
        userKey: "USR-001",
        licenseId: "license-1",
        enabled: true
      },
      {
        userId: "user-2",
        name: "Luca",
        lastName: "Bianchi",
        email: "luca.bianchi@example.com",
        companyName: "Beta Srl",
        piva: "IT98765432109",
        street: "Corso Italia 5",
        city: "Torino",
        zip: "10100",
        province: "TO",
        state: "IT",
        userKey: "USR-002",
        licenseId: "license-2",
        enabled: false
      },
      {
        userId: "user-3",
        name: "Giulia",
        lastName: "Verdi",
        email: "giulia.verdi@example.com",
        companyName: "Gamma Tech",
        piva: "IT45678912345",
        street: "Via Dante 14",
        city: "Bologna",
        zip: "40121",
        province: "BO",
        state: "IT",
        userKey: "USR-003",
        licenseId: "license-3",
        enabled: true
      },
      {
        userId: "user-4",
        name: "Sara",
        lastName: "Neri",
        email: "sara.neri@example.com",
        companyName: "Delta Networking",
        piva: "IT56473829101",
        street: "Via Mazzini 8",
        city: "Firenze",
        zip: "50100",
        province: "FI",
        state: "IT",
        userKey: "USR-004",
        licenseId: "license-4",
        enabled: true
      },
      {
        userId: "user-5",
        name: "Davide",
        lastName: "Russo",
        email: "davide.russo@example.com",
        companyName: "Omega Systems",
        piva: "IT19283746550",
        street: "Via Napoli 22",
        city: "Napoli",
        zip: "80100",
        province: "NA",
        state: "IT",
        userKey: "USR-005",
        licenseId: "license-5",
        enabled: false
      }
    ];

    const start = (paging.pageIndex - 1) * paging.pageSize;
    const end = start + paging.pageSize;
    const pageData = allData.slice(start, end);

    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 12,
      data: {
        count: allData.length,
        items: pageData
      }
    });
  }

  GETUserByID(userId: string): Observable<UserList> | any {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 8,
      data: {
        name: "Mario",
        lastName: "Rossi",
        email: "mario.rossi@example.com",
        companyName: "Acme S.p.A.",
        piva: "IT12345678901",
        street: "Via Roma 1",
        city: "Milano",
        zip: "20100",
        province: "MI",
        state: "IT",
        userKey: "USR-001",
        licenseId: "license-1",
        enabled: true
      }
    });
  }

  POSTUser(userData: UserList): Observable<UserList> | any {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 10,
      data: true
    });
  }

  PUTUser(userId: string, userData: UserList): Observable<UserList> | any {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 9,
      data: true
    });
  }

  DELETEUser(userId: string): Observable<boolean> | any {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 7,
      data: true
    });
  }

  PUTUserStatus(userId: string, enabled: boolean) {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 6,
      data: true
    });
  }

  POSTSendLicenseToUser(sendEmailBody: EmailLicense, userId: string) {
    return of({
      success: true,
      errorCode: 0,
      errorMessage: null,
      elapsed: 15,
      data: {
        licenseGenerated: true,
        senEmail: true
      }
    });
  }
}
